<template>
    <app-data-table
        :fields="fields"
        :items="data.data"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="actions" slot-scope="{ item }">
            <b-button
                variant="danger"
                size="sm"
                @click="startRemove(item)"
                ><i class="fa fa-trash-o" aria-hidden="true"></i
            ></b-button>
        </template>
    </app-data-table>
</template>
<script>
export default {
    data() {
        return {
            fields: [
                {
                    key: 'person.name',
                    label: 'Persona autorizada',
                    filter: true,
                },
                {
                    key: 'person.document',
                    label: 'Documento',
                    filter: false,
                },
                {
                    key: 'destination.name',
                    label: 'Destino',
                    filter: true,
                },
                {
                    key: 'visitor_type.name',
                    label: 'Tipo de visitante',
                    filter: true,
                },
                {
                    key: 'authorized_by.name',
                    label: 'Autorizado por',
                    filter: true,
                },
                {
                    key: 'created_at',
                    label: 'Fecha de autorización',
                    filter: true,
                },
                {
                    key: 'due_date',
                    label: 'Fecha de vigencia',
                    filter: true,
                },
                {
                    key: 'notes',
                    label: 'Notas',
                    filter: true,
                },
                {
                    key: 'actions',
                    label: 'Acciones',
                },
            ],
        }
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        startRemove: {
            type: Function,
            required: true,
        },
        onChangePage: {
            type: Function,
            required: true,
        },
    },
    methods: {
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
    },
    created() {
        this.isAdminClient =
            this.user.profile.slug === 'cliente-admin' ? true : false
    },
}
</script>
